export class SimpAn {
    constructor() {}
    commonStep = 'stepper.form.commun.SIMP.step';
    step = 'stepper.form.simp_an.step';
    step1 = 'stepper.form.simp_an.step1';
    step2 = 'stepper.form.simp_an.step2';
    step3 = 'stepper.form.simp_an.step3';
    step4 = 'stepper.form.simp_an.step4';
    step5 = 'stepper.form.simp_an.step5';
  }
